import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';

export const ScreenEmpty = styled.div`
  height: 100%;
  width: 100%;
  padding-top: 85px;
`;

export const ScreenMessage = styled.p`
  width: 350px;
  text-align: center;
  ${mixins.fontStyle(styles.colors.GRAY_MEDIUM_3, styles.fontSizes.SIZE_4, '500')}
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./src/components/ScreenEmpty/style.js